import createReducer from './baseReducer';

export default createReducer('holidays', 'holiday');
